import { toastManager } from "@/lib/toast"

export function showGenericErrorToast(refresh?: boolean): void {
  toastManager.add({
    type: "error",
    description: refresh
      ? "Sorry, something went wrong. Please try refreshing the page."
      : "Sorry, something went wrong. Please try again.",
  })
}
